var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchDurationArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.95 14.45l-8.3 8.8c-.15.2-.4.25-.6.25-.2 0-.4-.05-.55-.2-.35-.3-.35-.8-.05-1.1l7-7.5H2.6c-.45 0-.8-.35-.8-.75s.35-.85.8-.85h18.85l-7-7.45c-.3-.3-.3-.8.05-1.1.35-.3.85-.3 1.15.05l8.3 8.8c.3.3.3.75 0 1.05z",
    fill: "currentColor"
  })));
}
export default SvgSearchDurationArrowIcon;